<template>
    <div
        ref="tableContent"
        class="content"
    >
        <div class="kgr-row kgr-postfix kgr-postfix--gutters kgr-postfix--bottom">
            <div class="kgr-postfix__fluid">
                {{ $t('Anzahl gefundener Mitglieder: {count}', { count: attendancesByMembers.length }) }}
            </div>
        </div>
        <table
            vue:is="kgr-table"
            class="kgr-table kgr-table--block data-table table-groups table-employees printable"
            searching="false"
        >
            <thead>
                <tr class="kgr-table__row">
                    <th
                        vue:is="kgr-th"
                        class="kgr-table__cell kgr-table__cell--headline"
                    >
                        {{ $t('Mitglied') }}
                    </th>
                    <th
                        vue:is="kgr-th"
                        sortable
                        class="kgr-table__cell kgr-table__cell--headline"
                    >
                        {{ $t('Vorname') }}
                    </th>
                    <th
                        vue:is="kgr-th"
                        sortable
                        class="kgr-table__cell kgr-table__cell--headline"
                    >
                        {{ $t('Nachname') }}
                    </th>
                    <th
                        vue:is="kgr-th"
                        sortable
                        class="kgr-table__cell kgr-table__cell--headline"
                    >
                        {{ $t('Geburtsdatum') }}
                    </th>
                    <th
                        vue:is="kgr-th"
                        sortable
                        class="kgr-table__cell kgr-table__cell--headline membership-column"
                    >
                        {{ $t('Mitgliedschaft') }}
                    </th>
                    <th
                        vue:is="kgr-th"
                        sortable
                        class="kgr-table__cell kgr-table__cell--headline"
                    >
                        {{ $t('Mitgliedsnummer') }}
                    </th>
                    <th
                        vue:is="kgr-th"
                        sortable
                        class="kgr-table__cell kgr-table__cell--headline"
                    >
                        {{ $t('Bemerkung') }}
                    </th>
                    <th
                        vue:is="kgr-th"
                        sortable
                        class="kgr-table__cell kgr-table__cell--headline attendances-column"
                    >
                        {{ $t('Anwesenheiten') }}
                    </th>
                </tr>
            </thead>
            <tbody>
                <kgr-member-attendances-row
                    v-for="attendancesByMember in attendancesByMembers"
                    :key="attendancesByMember.member.id"
                    :attendances-by-member="attendancesByMember"
                    :is-current-day="isCurrentDay"
                    :pending-actions="pendingActions"
                    :attendance-in-edit-mode="attendanceInEditMode"
                    :pending-attendances="pendingAttendances"
                    @cancelEdit="$emit('cancelEdit')"
                    @actionTriggered="$emit('actionTriggered', $event)"
                    @editAttendance="$emit('editAttendance', $event)"
                    @attendanceUpdated="$emit('attendanceUpdated', $event)"
                    @attendanceRemoved="$emit('attendanceRemoved', $event)"
                />
            </tbody>
        </table>
    </div>
</template>

<script>
import KgrMemberAttendancesRow from './MemberAttendancesRow.vue';

export default {
    name: 'KgrMemberAttendances',
    components: {
        KgrMemberAttendancesRow,
    },
    props: {
        attendancesByMembers: {
            type: Array,
            required: true,
        },
        isCurrentDay: {
            type: Boolean,
            required: true,
        },
        pendingActions: {
            type: Array,
            required: true,
        },
        attendanceInEditMode: {
            type: String,
            required: false,
        },
        pendingAttendances: {
            type: Array,
            required: true,
        },
    },
    beforeUnmount() {
        this.$refs.tableContent.innerHTML = null;
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss">
    th {
    &.date {
        width: 65px;
    }
}

.attendances-column {
    min-width: 215px;
}

.membership-column {
    min-width: 85px;
    max-width: 85px;
}

.content {
    padding-top: 15px;
}
</style>
